<template>
	<el-row :gutter="24" class="content">
		<el-col :span="12">
			<gc-group-detail :data="deviceBasicInfo"></gc-group-detail>
		</el-col>
		<el-col :span="12">
			<DiagnosisAnalyze isAnalyzeDetails :detail="detail" resultKey="communicateResult" />
		</el-col>
		<el-col v-if="aiRunning || aiResult || aiNotRequired" :span="24">
			<AiDiagnosis :result="aiResult" :running="aiRunning" :not-required="aiNotRequired" />
		</el-col>
		<el-col :span="24" class="box-table">
			<CommunicateDetails :detail="detail" diagnosis-mode="DEFAULT" />
		</el-col>
	</el-row>
</template>

<script>
import DiagnosisAnalyze from '../components/DiagnosisAnalyze'
import AiDiagnosis from '../components/AiDiagnosis.vue'
import CommunicateDetails from '../components/CommunicateDetails'
export default {
	components: { DiagnosisAnalyze, CommunicateDetails, AiDiagnosis },
	props: {
		detail: {
			type: Object,
			default: () => {},
		},
		aiResult: { type: Object, default: null },
		aiRunning: Boolean,
		aiNotRequired: Boolean,
	},
	data() {
		return {}
	},
	computed: {
		deviceBasicInfo() {
			return {
				title: '设备信息',
				row: 2,
				labelWidth: 75,
				list: [
					{
						key: 'deviceNo',
						label: '设备通讯编号',
						value: this.detail.deviceNo,
					},
					{
						key: 'deviceTypeName',
						label: '设备型号',
						value: this.detail.deviceTypeName,
					},
					{
						key: 'protocolNo',
						label: '协议',
						value: this.detail.protocolNo,
					},
					{
						key: 'lastCommunicateTime',
						label: '最新通讯时间',
						value: this.detail.lastCommunicateTime,
						col: 2,
					},
				],
			}
		},
	},
}
</script>
<style lang="scss" scoped>
.content {
	min-height: 100%;
}
.box-table {
	height: 520px;
	margin-top: 20px;
}

::v-deep .group-detail-item .group-detail-name {
	width: 100px !important;
}
</style>
